{
  "fr": {
    "nav": {
      "home": "Accueil",
      "back": "Retour",
      "navigation": "Navigation",
      "ships": {
        "index": "Vaisseaux"
      },
      "compare": {
        "index": "Comparer",
        "ships": "Comparer les Vaisseaux"
      },
      "manufacturers": "Fabricants",
      "images": "Images",
      "videos": "Vidéos",
      "shipHistory": "Historique",
      "hangar": {
        "index": "Mon Hangar",
        "vehicleLoadouts": "Loadouts",
        "inventories": "Inventories",
        "vehicleCargo": "Cargaison"
      },
      "login": "Connexion",
      "logout": "Déconnexion",
      "apiV1": "API v1",
      "apiV1Schema": "Schéma",
      "apiV1Pagination": "Pagination",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schéma",
      "embed": "Widget Intégré",
      "signUp": "S'inscrire",
      "privacyPolicy": "Politique de confidentialité",
      "impressum": "Mentions légales",
      "fleets": {
        "index": "Flottes",
        "add": "Créer une nouvelle Flotte",
        "invites": "Invitations",
        "ships": "Vaisseaux",
        "members": {
          "index": "Members",
          "invites": "Invites",
          "worldmap": "Carte du monde",
          "starmap": "Carte stellaire"
        },
        "stats": "Statistiques",
        "logistics": {
          "index": "Logistics"
        },
        "missions": {
          "index": "Missions",
          "edit": {
            "basic": "Général",
            "description": "Description",
            "teams": "Équipes & places"
          }
        },
        "events": {
          "index": "Événements",
          "calendar": "Calendrier",
          "edit": {
            "basic": "Général",
            "description": "Description",
            "teams": "Équipes & places"
          }
        },
        "settings": {
          "index": "Paramètres",
          "fleet": "Paramètres de Flotte",
          "membership": "Paramètres d'Adhésion",
          "roles": "Rôles",
          "notifications": "Notifications",
          "discord": "Discord",
          "calendar": "Calendrier",
          "features": "Fonctionnalités"
        }
      },
      "rsiProfile": "Profil RSI",
      "rsiHangar": "Hangar RSI",
      "tools": {
        "index": "Outils",
        "travelTimes": "Temps de Voyage",
        "cargoGrids": "Grilles de Fret"
      },
      "api": "Documentation API",
      "stats": "Statistiques",
      "toggleSlimCollapse": "Réduire",
      "toggleSlimExpand": "Développer",
      "roadmap": {
        "index": "Feuille de Route",
        "overview": "Vue d'ensemble",
        "changes": "Changements",
        "ships": "Feuille de Route des Vaisseaux"
      },
      "rsiVerification": "Vérification RSI",
      "settings": {
        "index": "Paramètres",
        "profile": "Profil",
        "account": "Compte",
        "security": "Sécurité",
        "notifications": "Notifications",
        "calendar": "Calendrier",
        "hangar": "Hangar",
        "privacy": "Confidentialité",
        "features": "Fonctionnalités",
        "connections": "Connexions",
        "oauthApplications": "Apps OAuth",
        "verify": "Vérification du compte RSI"
      },
      "reload": "Mise à jour disponible!",
      "visualTests": {
        "index": "Tests Visuels",
        "panels": "Panneaux",
        "buttons": "Boutons",
        "events": "Événements",
        "typography": "Typographie",
        "forms": "Formulaires",
        "tables": "Tableaux",
        "lists": "Listes",
        "metrics": "Métriques",
        "states": "États",
        "notifications": "Notifications",
        "syncModal": "Modale Sync",
        "overlays": "Superpositions",
        "supportHint": "Indicateur de soutien",
        "media": "Médias",
        "charts": "Graphiques",
        "chips": "Chips",
        "groups": {
          "foundations": "Fondations",
          "data": "Données",
          "feedback": "Retours"
        },
        "notificationCenter": "Centre de notifications"
      },
      "admin": {
        "index": "Admin",
        "models": {
          "index": "Modèles",
          "create": "Créer un Modèle",
          "edit": {
            "index": "Données de Base",
            "metrics": "Métriques",
            "prices": "Prix",
            "docks": "Quais",
            "modules": "Modules",
            "paints": "Peintures",
            "images": "Images",
            "videos": "Vidéos",
            "cargoAndFuel": "Fret et Carburant",
            "cargoHolds": "Soutes à cargaison",
            "fleetchart": "Images Fleetchart",
            "positions": "Postes",
            "hardpoints": "Points d'attache",
            "loaners": "Prêts",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Améliorations",
            "packages": "Paquets",
            "history": "Historique"
          }
        },
        "modelPaints": {
          "index": "Peintures",
          "create": "Créer une Peinture"
        },
        "modelModules": {
          "index": "Modules",
          "create": "Créer un Module",
          "edit": {
            "index": "Données de Base",
            "models": "Modèles",
            "prices": "Prix",
            "hardpoints": "Points de Fixation",
            "cargoHolds": "Soutes à cargaison",
            "history": "Historique"
          }
        },
        "unlistedModels": {
          "index": "Vaisseaux non listés"
        },
        "modelModulePackages": {
          "index": "Paquets de Modules",
          "create": "Créer un Paquet de Modules"
        },
        "components": {
          "index": "Composants",
          "edit": {
            "index": "Données de base",
            "prices": "Prix",
            "history": "Historique"
          }
        },
        "manufacturers": {
          "index": "Fabricants",
          "edit": {
            "index": "Données de base",
            "models": "Vaisseaux",
            "components": "Composants",
            "equipment": "Équipement",
            "modules": "Modules"
          }
        },
        "images": {
          "index": "Images"
        },
        "users": {
          "index": "Utilisateurs",
          "edit": "Modifier",
          "fleets": "Flottes",
          "inventories": "Inventaires"
        },
        "fleets": {
          "index": "Flottes",
          "edit": "Modifier",
          "members": "Membres",
          "history": "Historique",
          "roles": "Rôles",
          "inventories": "Inventaires"
        },
        "destroyedFleets": {
          "index": "Flottes détruites"
        },
        "vehicles": {
          "index": "Véhicules"
        },
        "admins": {
          "index": "Administrateurs"
        },
        "oauthApplications": {
          "index": "Apps OAuth"
        },
        "maintenance": {
          "index": "Maintenance",
          "pghero": "PG-Hero",
          "features": "Fonctionnalités",
          "workers": "Travailleurs",
          "tasks": "Tâches",
          "imports": "Imports",
          "rsiApiStatus": "État API RSI",
          "buildCompare": "Comparer les builds"
        },
        "supporterContributions": {
          "index": "Contributions des soutiens",
          "new": "Nouvelle contribution",
          "edit": "Modifier la contribution"
        },
        "fundingGoals": {
          "index": "Objectifs de financement",
          "new": "Nouvel objectif de financement",
          "edit": "Modifier l'objectif de financement"
        },
        "notifications": {
          "index": "Notifications"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Base Data"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Base Data",
            "prices": "Prices"
          }
        },
        "visualTests": {
          "index": "Tests Visuels",
          "notifications": "Notifications"
        },
        "groups": {
          "catalogue": "Catalogue",
          "community": "Communauté",
          "people": "Personnes",
          "system": "Système"
        }
      },
      "notifications": "Notifications"
    }
  }
}
